<template>
    <div class="step-a-wrapper mt-30 mb-30">

        <!-- <pre>{{ dataProfileGrad[0] }}</pre> -->
        <!-- {{ dataProfileGrad[0].user_code }} -->

        <a-descriptions bordered :size="size" layout="vertical" :column="{ xxl: 4, xl: 3, lg: 3, md: 3, sm: 2, xs: 1 }">
            <template slot="title">
                <h5 class="mt-0 mb-10 font-web"><a-icon style="font-size: 20px;" type="solution" /> Graduate Profile
                </h5>
            </template>
            <a-descriptions-item v-if="dataProfileGrad[0].form_survey" :span="3">
                <template slot="label">
                    <div class="text-center">
                        <h6 class="mt-0 mb-0 font-web">Please present this QR code at the First Rehearsal registration.
                        </h6>
                    </div>
                </template>
                <div style="display: flex; justify-content: center; align-items: center;" class="mb-10">
                    <qr-code :text="dataProfileGrad[0].user_code" :size="250"></qr-code>
                </div>
            </a-descriptions-item>
            <a-descriptions-item v-if="dataProfileGrad[0].form_survey">
                <template slot="label">
                    <div class="text-center">
                        <h6 class="mt-0 mb-0 font-web">Graduation Number</h6>
                    </div>
                </template>
                <div style="display: flex; justify-content: center; align-items: center;">
                    <h1 class="mt-0 mb-0" style="font-size: 72px; font-weight: 800; color: #722ed1; line-height: 1;">{{ dataProfileGrad[0].present_order }}</h1>
                </div>
            </a-descriptions-item>
            <a-descriptions-item v-if="dataProfileGrad[0].form_survey" label="Graduation Schedule" :span="2">
                <div style="margin-bottom: 20px;" v-if="Number(dataProfileGrad[0].present_order) >= 5450 && Number(dataProfileGrad[0].present_order) <= 5819">
                    <h4 class="mt-0 mb-10 font-web" style="text-decoration: underline;">Rehearsal Group 1</h4>
                    <div style="justify-content: center; align-items: center;">
                        <small style="font-size: 16px;">First Rehearsal:</small>
                        <h4 class="mt-0 mb-0"><span class="text-danger">Thursday, October 1, 2026* (8:00 A.M.)</span></h4>
                        <small style="font-size: 16px;">Grand Rehearsal:</small>
                        <h6 class="mt-0 mb-0"><span class="text-danger">Saturday, October 3, 2026 (1:30 P.M.)</span></h6>
                        <small style="font-size: 16px;">Commencement Ceremony:</small>
                        <h6 class="mt-0 mb-0"><span class="text-danger">Tuesday, October 6, 2026 (9:30 A.M.)</span></h6>
                    </div>
                </div>

                <div v-if="Number(dataProfileGrad[0].present_order) >= 5820 && Number(dataProfileGrad[0].present_order) <= 6242">
                    <h4 class="mt-0 mb-10 font-web" style="text-decoration: underline;">Rehearsal Group 2</h4>
                    <div style="justify-content: center; align-items: center;">
                        <small style="font-size: 16px;">First Rehearsal:</small>
                        <h4 class="mt-0 mb-0"><span class="text-danger">Friday, October 2, 2026* (8:00 A.M.)</span></h4>
                        <small style="font-size: 16px;">Grand Rehearsal:</small>
                        <h6 class="mt-0 mb-0"><span class="text-danger">Saturday, October 3, 2026 (1:30 P.M.)</span></h6>
                        <small style="font-size: 16px;">Commencement Ceremony:</small>
                        <h6 class="mt-0 mb-0"><span class="text-danger">Tuesday, October 6, 2026 (9:30 A.M.)</span></h6>
                    </div>
                </div>
            </a-descriptions-item>
            <!--  
                <a-descriptions-item v-if="dataProfileGrad[0].form_survey" label="Survey Status" :span="3">
                    <a-alert message="Success form survey submitted" type="success" show-icon />
                </a-descriptions-item>
                <a-descriptions-item v-if="dataProfileGrad[0].form_survey" label="Remark" :span="2">
                    {{ dataProfileGrad[0].msg }}
                </a-descriptions-item>
                <a-descriptions-item v-if="dataProfileGrad[0].form_survey" label="Announcement" :span="2">
                    {{ dataProfileGrad[0].remark }}
                </a-descriptions-item>
            -->
            <a-descriptions-item v-if="!dataProfileGrad[0].form_survey" label="Survey Status" :span="3">
                <a-row type="flex" justify="center">
                    <a-col :xs="24" :sm="22" :md="20" :lg="16" :xl="12">
                        <h6 class="mt-0 mb-0 text-center">
                            Complete this form to receive your
                            <strong class="text-danger">QR code</strong> for <br>
                            First Rehearsal check-in and your
                            <strong class="text-danger">Graduation Number.</strong>
                        </h6>
                        <br>
                        <div @click="openFormGoogle(`${dataProfileGrad[0].remark}`, dataProfileGrad[0].user_code)">
                            <a-card-meta>
                                <template slot="title">
                                    <h5 class="mt-0 mb-0 font-web">MUIC Graduate Employment Survey</h5>
                                    <small> of Academic Year 2024 </small>
                                </template>

                                <template slot="description">
                                    <p class="mt-0 mb-0 font-web">
                                        The Graduate Survey of Mahidol University International College (MUIC) is an
                                        annual report in which all survey questions are being reviewed, examined and
                                        updated yearly in order to bridge the gap between Mahidol University
                                        requirements
                                        and Mahidol University International College.
                                    </p>

                                    <p class="mt-10 mb-0 font-web text-danger">
                                        For more information regarding the PDPA, please visit:
                                        <a href="https://shorturl.at/R08ge" target="_blank">
                                            Read more.
                                        </a>
                                    </p>
                                </template>
                            </a-card-meta>
                            <div class="mt-20 mb-20 text-center">
                                <a-button type="primary" icon="edit">
                                    Click here to complete the questionnaire.
                                </a-button>
                            </div>
                        </div>
                    </a-col>
                </a-row>
            </a-descriptions-item>
            <!--  
                <a-descriptions-item label="CHECK-INS Status" :span="3">
                    <a-alert message="Success check-ins" type="success" show-icon />
                </a-descriptions-item>
            -->
            <!--  
                <a-descriptions-item label="Problem request data Graduate Profile !">
                    <div class="mt-10">
                        <p class="mt-10 mb-0">
                            Please contact
                            <strong class="text-primary"
                                >The Office of Student Affairs (MUIC)</strong
                            >
                            <br>
                            E-mail:
                            <strong class="text-primary"
                                >icsa@mahidol.ac.th</strong
                            >
                            <br>
                            Phone:
                            <strong class="text-primary"
                                >02-700-5000 ext.1120, 1115 or 1242 Fax
                                02-441-0966</strong
                            >
                        </p>
                    </div>
                </a-descriptions-item>
            -->
        </a-descriptions>

    </div>
</template>

<script>
import moment from 'moment';

export default {
    props: {
        dataProfileGrad: {
            type: Array,
            default: () => [],
        },
        dataPeriod: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            size: 'middle'
        };
    },
    mounted() { },
    methods: {
        openFormGoogle(url, idStudent) {
            window.open(`${url}${idStudent}`, "_blank");
        },
        getLabel(number) {
            if (number >= 1840 && number <= 2326) {
                return "Friday, October 3, 2025 (08:00–16:00 hrs.)";
            } else if (number >= 2327 && number <= 2751) {
                return "Saturday, October 4, 2025 (08:00–16:00 hrs.)";
            } else {
                return "-"; // ถ้าไม่อยู่ในช่วงที่กำหนด
            }
        }
    },
};
</script>

<style scoped></style>